<template>
  <div v-if="networkResponse.status !== STATUSES.SUCCESS && networkResponse.status !== STATUSES.TEAPOT"
       class="app-alert-error app-system-alert" id="appAlert"
       role="alert" ref="appAlert">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p ref="alertMessage" tabindex="-1">{{ message }}</p>
  </div>
</template>

<script setup>
import { ref, computed, watch, onUpdated, onMounted } from 'vue';
import { useStore } from 'vuex';
import MESSAGES from '@/assets/data/_systemFeedback';

// Vuex store
const store = useStore();

// Reactive State
const message = ref('');

// Refs for accessing DOM elements
const appAlert = ref(null);
const alertMessage = ref(null);

// Computed Properties
const STATUSES = computed(() => store.state.user.STATUSES);
const networkResponse = computed(() => store.state.user.networkResponse);

// Methods 
const setMessage = () => {
  if (networkResponse.value.status != 461) {
    const alert = MESSAGES.find(item => item.status === networkResponse.value.status);
    
    if (networkResponse.value.message != null && networkResponse.value.message != '') {
      message.value = networkResponse.value.message;
    } else {
      message.value = alert ? alert.message : `Unknown error ${networkResponse.value.status}`;
    }
  } else {
    message.value = networkResponse.value.message;
  }
};

// Watchers
watch(networkResponse, () => {
  setMessage();
});

// Lifecycle Hooks
onMounted(() => {
  setMessage();
});

onUpdated(() => {
  if (alertMessage.value) {
    alertMessage.value.focus();
  }
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
